import "./Tasks.css";

import { OrganisationTypeConstants } from "../../../../constants";
import { CompleteTaskModal, WorkflowTaskPanel } from "../../../../templates/WorkflowTaskPanel";
import { Button, Column, CursorDataGrid, Row, TagFilter } from "../../../../widget";
import { NewTaskModal } from "../../components/NewTaskModal";
import { useTasks } from "./useTasks";

const Tasks = (): JSX.Element => {
  const {
    refreshTasks,
    workflow,
    handleRefresh,

    selectedPanelTask,
    showWorkflowTaskPanel,
    handleCloseWorkflowTaskPanel,
    createTaskIsGeneral,
    showNewTaskModal,
    setShowNewTaskModal,
    handleNewTask,

    canCreateGeneralTask,

    landholdingName,
    landholdingGroupUuid,

    tagsFilterSelectData,
    tagsFilterValues,
    onTagsFilter,

    selectedCompleteTask,
    showCompleteTaskModal,
    handleCloseCompleteTaskModal,

    tasksOnChange,
    isTasksLoading,
    columns,
    defaultSortingCriteria,
    currentUserType,
  } = useTasks();

  return (
    <div className="TemplateTabCard">
      <Row spacingV="ml">
        <Column span={12}>
          <Row spacingV="ml" justify="between" align="center">
            <Column span={6}>
              <h2>Tasks</h2>
            </Column>
            <Column span={6}>
              <div className="LandholdingTasksButtons">
                {/* A landholding has no workflow, so only a general task can be created from here. */}
                {canCreateGeneralTask && (
                  <Button text="New task" fontWeight="light" size="small" onClick={() => setShowNewTaskModal(true)} />
                )}
              </div>
            </Column>
          </Row>
          <div className="LandholdingTasksFilters">
            <h3>Filter by</h3>
            <TagFilter tags={tagsFilterSelectData} values={tagsFilterValues} onChange={onTagsFilter} />
          </div>
          <CursorDataGrid
            columns={columns}
            clientSide={false}
            filterable
            sortable
            onChange={tasksOnChange}
            data={[]}
            pagination={{ pageSize: 10 }}
            refresh={refreshTasks}
            noDataMessage="No tasks to display"
            dataIsLoading={isTasksLoading}
            defaultSortingCriteria={defaultSortingCriteria}
            variant={currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "seed" : "default"}
          />
        </Column>
      </Row>
      <NewTaskModal
        show={showNewTaskModal}
        canCreateWorkflowTask={false}
        canCreateGeneralTask={canCreateGeneralTask}
        onCancel={() => setShowNewTaskModal(false)}
        onConfirm={handleNewTask}
      />
      <WorkflowTaskPanel
        task={selectedPanelTask}
        currentStepUuid={selectedPanelTask?.step?.uuid}
        workflow={workflow}
        isGeneralTask={createTaskIsGeneral}
        parentName={landholdingName}
        // A general task created here has no workflow to derive its parent from, so it hangs off the landholding.
        parentObjectType="Landholding"
        parentObjectUuid={landholdingGroupUuid}
        show={showWorkflowTaskPanel}
        refresh={refreshTasks}
        handleRefresh={handleRefresh}
        onClose={handleCloseWorkflowTaskPanel}
      />
      {selectedCompleteTask && (
        <CompleteTaskModal
          task={selectedCompleteTask}
          show={showCompleteTaskModal}
          closeModal={handleCloseCompleteTaskModal}
          closePanel={handleCloseCompleteTaskModal}
          handleRefresh={handleRefresh}
        />
      )}
    </div>
  );
};

export default Tasks;
